import { ArrowDropUp, ArrowDropDown } from '@mui/icons-material';
import { Alert, Box, Grid, IconButton, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ControlledCheckBox from 'src/shared/components/form/controlledCheckbox';
import { getPaymentMethodDescription } from 'src/shared/models/enums/availablePaymentMethods.enum';
import { PaymentMethods } from 'src/shared/models/invoiceGroup/invoiceGroup';

type FormValues = {
  paymentMethods: PaymentMethods[];
};

export const ActivePaymentOptionsInfo = () => {
  const { t } = useTranslation();

  const { control, setValue, getValues, watch } = useFormContext<FormValues>();
  const { fields, move } = useFieldArray({
    control,
    name: 'paymentMethods',
  });

  const syncPositions = () => {
    const items = getValues('paymentMethods') as PaymentMethods[] | undefined;
    if (!items) return;

    items.forEach((_, index) => {
      setValue(`paymentMethods.${index}.pos`, index + 1);
    });
  };

  const handleMoveUp = (index: number) => {
    if (index === 0) return;
    move(index, index - 1);
    syncPositions();
  };

  const handleMoveDown = (index: number) => {
    if (index === fields.length - 1) return;
    move(index, index + 1);
    syncPositions();
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} mb={-1} mt={-1}>
        <Typography variant='h6' sx={{ fontWeight: 'bold', mb: 1 }}>
          {t('invoice:adminInvoiceGroupDetailPage.activePaymentsOpt')}
        </Typography>
      </Grid>

      <Grid item xs={12} mb={-1} mt={-1}>
        {fields.map((method, index) => {
          const activeVal = watch(`paymentMethods.${index}.active`);
          const preSelVal = watch(`paymentMethods.${index}.preSelected`);

          return (
            <Grid container alignItems='center' key={method.id} sx={{ mb: { xs: 0, sm: 0, md: 0, lg: 1 } }}>
              <Grid item xs={6} sm={6} md={6} lg={5} mb={-0.5}>
                <ControlledCheckBox
                  label={getPaymentMethodDescription(method.type, t)}
                  name={`paymentMethods.${index}.active`}
                  value={activeVal}
                  disabled
                />
              </Grid>
              <Grid item xs={3}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <IconButton
                    sx={{ mr: -1 }}
                    onClick={() => {
                      handleMoveUp(index);
                    }}
                    // disabled={index === 0 || loading} // PUT ej möjligt för tillfället
                    disabled
                  >
                    <ArrowDropUp />
                  </IconButton>

                  <IconButton
                    onClick={() => {
                      handleMoveDown(index);
                    }}
                    // disabled={index === fields.length - 1 || loading} // PUT ej möjligt för tillfället
                    disabled
                  >
                    <ArrowDropDown />
                  </IconButton>

                  {method.preSelected === '1' && (
                    <Box sx={{ mt: 1, ml: 1 }}>
                      <ControlledCheckBox
                        label={t('invoice:adminInvoiceGroupDetailPage.preSelected')}
                        name={`paymentMethods.${index}.preSelected`}
                        value={preSelVal}
                        disabled
                      />
                    </Box>
                  )}
                </Box>
              </Grid>
              {/* <Grid item xs={3} mt={1}>
                {method.preSelected === '1' && (
                  <ControlledCheckBox
                    label={t('invoice:adminInvoiceGroupDetailPage.preSelected')}
                    name={`paymentMethods.${index}.preSelected`}
                    value={preSelVal}
                    disabled
                  />
                )}
              </Grid> */}
            </Grid>
          );
        })}
      </Grid>

      <Grid item xs={12} sm={10} mt={1}>
        <Alert sx={{ fontWeight: 600 }} severity='info'>
          {t('invoice:adminInvoiceGroupDetailPage.paymentOptDescription')}
        </Alert>
      </Grid>
    </Grid>
  );
};
